import React from "react";
import { Close } from "@mui/icons-material";
import "./autoSubmitErrorPopup.css";
import { useIntl } from "react-intl";
import { Modal } from "@mui/material";
import Button from "../../common/components/Button";

export default function AutoSubmitErrorPopup({ showErrorPopup, onClose }) {
  const intl = useIntl();

  if (!showErrorPopup?.show) return null;

  return (
    <Modal
      open={showErrorPopup?.show}
      onClose={onClose}
      className="error-popup-modal"
    >
      <div className="error-popup-background">
        <div className="error-popup-box">
          {/* Header */}
          <div className="error-popup-header">
            <div className="error-popup-title-wrapper">
              {/* <Warning className="error-popup-icon" /> */}
              <h2 className="error-popup-title">{showErrorPopup?.title}</h2>
            </div>
            <button
              className="error-popup-close-btn"
              onClick={onClose}
              aria-label="Close"
            >
              <Close />
            </button>
          </div>

          {/* Content */}
          <div className="error-popup-content">
            {showErrorPopup?.errors?.map((error, index) => (
              <p className="error-popup-message" key={index}>
                {error}
              </p>
            ))}
          </div>

          {/* Footer */}
          <div className="error-popup-footer">
            <Button
              title={intl.formatMessage({ id: "close" })}
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
